// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IMessagesOfferRequest,
  TMessagesOfferModel,
  IMappers,
  TMessagesOfferResponse,
  IMessagesOfferResponse,
  IMessagesOfferResponseError,
} from './types';

export const defaultConfig: TMessagesOfferModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/messages/offer/',
  requestType: 'json',
} as TMessagesOfferModel;

export function createMessagesOfferModel(parameters: IMessagesOfferRequest): TMessagesOfferModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IMessagesOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IMessagesOfferRequest;
}

export async function fetchMessagesOffer<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IMessagesOfferOptions<TResponse200, TResponse400>): Promise<TMessagesOfferResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createMessagesOfferModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMessagesOfferResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IMessagesOfferResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TMessagesOfferResponse;
}
